import React, { useEffect, useState } from "react";
import unsplash from "../../api/unsplash";
import {
  DataGridPro,
  itIT,
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from "../../utils/PersistedDataGridPro";
import {
  IconButton,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Popover,
  DialogActions,
  Box,
  Step,
  StepLabel,
  Stepper,
  CircularProgress,
  ButtonBase,
  ButtonGroup,
  Zoom,
  DialogContentText,
  LinearProgress,
} from "@mui/material";
import VisiteMediche from "../VIsiteMediche";
import { Check, Close, CheckBox, Delete, Edit } from "@mui/icons-material";
import {
  LocalizationProvider,
  DatePicker,
  PickersDay,
  TimePicker,
} from "@mui/x-date-pickers";
import { AdapterMoment as DateAdapter } from "@mui/x-date-pickers/AdapterMoment";

import momentTimezone from "moment-timezone";
import moment from "moment-timezone";
import GlobalSnackbar from "../Snackbar";
import { useLocation } from "react-router-dom";
import FileUploader from "../FileUploader";
import { CustomFooterPersonalized } from "../../utils/CustomFooterPersonalized";
import {
  applyAccertamentoVisitaEdit,
  buildAccertamentiVisitaRows,
  getAccertamentiVisitaSelectionChanges,
  getAccertamentiVisitaRowId,
  getAccertamentiVisitaSelectedRows,
  getAccertamentiVisitaSelectionRowIds,
  renderAccertamentoVisitaCell,
} from "../../utils/accertamentiVisitaRows";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Zoom timeout={2000} in={true} ref={ref} {...props} />;
});

const VisiteMedicheLavoratore = (props) => {
  const [visite, setVisite] = useState([]);
  const [loading, setLoading] = useState(true);
  const [mansioni, setMansioni] = useState();
  const [medici, setMedici] = useState();
  const [esiti, setEsiti] = useState();
  const [tipologiaVisita, setTipologiaVisita] = useState();
  const [visitaDaEliminare, setVisitaDaEliminare] = useState(null);
  const [openSnack, setOpenSnack] = useState(false);
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
  };
  const [snack, setSnack] = useState({
    severity: "success",
    messaggio: "Salvataggio Effettuato correttamente",
    open: false,
  });
  const authHeaders = {
    Authorization: `Bearer ${localStorage.getItem("jwt")}`,
  };

  const columns = [
    {
      filterable: false,
      field: "Actions",
      headerName: "Azioni",
      headerAlign: "center",
      hide: false,
      width: "150",
      align: "center",
      renderCell: (
        params, //mi aiuta a mettere il valore
      ) => (
        <ButtonGroup>
          <DettaglioVisitaMedica
            operation="new"
            title={"nuova visita medica"}
            visita={params.row}
            esiti={esiti}
            tipologiaVisita={tipologiaVisita}
            mansioni={mansioni}
            medici={medici}
            reloadVisite={reloadVisite}
            openSnack={openSnack}
            handleCloseSnack={handleCloseSnack}
            setSnack={setSnack}
            setOpenSnack={setOpenSnack}
            lavoratore={props.datiLavoratore}
          />
          <DeleteDialog visita={params.row} myFunction={deleteVisita} />

          {/* <Button
            aria-label="edit"
            startIcon={<Delete />}
            onClick={deleteVisita}
            className="ButtonMillerError"
            variant="contained"
          ></Button> */}

          {/* <IconButton
            aria-label="edit"
            onClick={() => document.getElementById("delete").click()}
            id="delete"
          >
            <Delete
              style={{ height: "2rem", width: "2rem", color: "#FF2768" }}
            />
          </IconButton> */}
        </ButtonGroup>
      ),
    },
    {
      field: "Data",
      headerName: "Data",
      width: 170,
      renderCell: (params) =>
        moment(params.row.Data).format("DD/MM/YYYY HH:mm:00"),
    },
    { field: "MedicoNomeCompleto", headerName: "Medico", width: 200 },
    { field: "DescMansione", headerName: "Mansione", width: 300 },
    { field: "Accertamenti", headerName: "Accertamenti", width: 300 },
    { field: "Note", headerName: "Note", width: 300 },
    { field: "DescEsito", headerName: "Esito", width: 200 },
    { field: "DescTipoVisita", headerName: "Tipo", width: 150 },
    {
      filterable: false,
      field: "PresenzaUnitaMobile",
      headerName: "Presenza Unita Mobile",
      width: 200,
      renderCell: (params) => {
        if (params.row.PresenzaUnitaMobile === 1) {
          return (
            <div>
              <input type="checkbox" checked readOnly />
            </div>
          );
        } else {
          return (
            <div>
              <input type="checkbox" disabled readOnly />
            </div>
          );
        }
      },
    },
  ];

  useEffect(() => {
    // è un loop qui carico i dati
    let active = true;
    const fetchData = async () => {
      setLoading(true);
      try {
        const [
          responseVisite,
          responseEsiti,
          responseTipologiaVisita,
          responseMansioni,
          responseMediciCliente,
        ] = await Promise.all([
          unsplash.get("visiteMediche", {
            headers: authHeaders,
            params: { lavoratore: props.lavoratore },
          }),
          unsplash.get("esiti", {
            headers: authHeaders,
          }),
          unsplash.get("tipologiaVisita", {
            headers: authHeaders,
          }),
          unsplash.get("mansioni", {
            params: { id: props.cliente },
            headers: authHeaders,
          }),
          unsplash.get("medici", {
            headers: authHeaders,
            params: { id: props.cliente },
          }),
        ]);

        if (!active) {
          return;
        }

        setVisite(responseVisite.data.data || []);
        setEsiti(responseEsiti.data.data || []);
        setTipologiaVisita(responseTipologiaVisita.data.data || []);
        setMansioni(responseMansioni.data.data || []);
        setMedici(responseMediciCliente.data.data || []);
      } catch (error) {
        if (!active) {
          return;
        }
        console.error("Errore caricamento visite lavoratore:", error);
        setVisite([]);
        setSnack({
          severity: "error",
          messaggio: "Errore durante il caricamento delle visite",
        });
        setOpenSnack(true);
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    };

    if (props.lavoratore) {
      fetchData();
    } else {
      setLoading(false);
    }

    return () => {
      active = false;
    };
  }, [props.lavoratore, props.cliente]);

  const reloadVisite = async () => {
    setLoading(true);
    try {
      let responsVisite = await unsplash.get("visiteMediche", {
        headers: authHeaders,
        params: { lavoratore: props.lavoratore },
      });
      setVisite(responsVisite.data.data || []);
    } catch (error) {
      console.error("Errore ricaricamento visite lavoratore:", error);
      setSnack({
        severity: "error",
        messaggio: "Errore durante il ricaricamento delle visite",
      });
      setOpenSnack(true);
    } finally {
      setLoading(false);
    }
  };

  const deleteVisita = async () => {
    if (!visitaDaEliminare) {
      setSnack({
        severity: "error",
        messaggio: "Seleziona una visita",
      });
      setOpenSnack(true);
    } else {
      try {
        await unsplash.delete("visiteMediche", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
          data: {
            visita: visitaDaEliminare[0].ID,
            lavoratore: props.lavoratore,
          },
        });

        await reloadVisite();
        setSnack({
          severity: "success",
          messaggio: "Visita Medica eliminata con successo",
        });
        setOpenSnack(true);
      } catch (error) {
        setSnack({
          severity: "error",
          messaggio:
            error?.response?.data?.message || "Errore durante l'eliminazione",
        });
        setOpenSnack(true);
      }
    }
  };
  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
        >
          <GridToolbarQuickFilter placeholder="Cerca..." />
        </Grid>
      </GridToolbarContainer>
    );
  }

  return (
    <>
      <GlobalSnackbar
        severity={snack.severity}
        messaggio={snack.messaggio}
        openSnack={openSnack}
        handleCloseSnack={handleCloseSnack}
      />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <div style={{ height: "58vh", width: "100%" }}>
            <DataGridPro
              initialState={{ pinnedColumns: { left: ["Actions"] } }}
              components={{
                Toolbar: CustomToolbar,
                Footer: CustomFooterPersonalized,
              }}
              slots={{
                loadingOverlay: LinearProgress,
              }}
              loading={loading}
              disableColumnMenu={true}
              localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
              rows={visite}
              getRowId={(visite) => visite.ID}
              columns={columns}
              onSelectionModelChange={(ids) => {
                const selectedIDs = new Set(ids);
                const selectedRowData = visite.filter((row) =>
                  selectedIDs.has(row.ID),
                );

                setVisitaDaEliminare(selectedRowData);
              }}
            />
          </div>
        </Grid>
      </Grid>
    </>
  );
};

export default VisiteMedicheLavoratore;

const DettaglioVisitaMedica = (props) => {
  const [open, setOpen] = useState(false);
  const [accertamenti, setAccertamenti] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectionModel, setSelectionModel] = useState([]);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [selectedAccertamento, setSelectedAccertamento] = useState(null);
  const [required, setRequired] = useState({
    medico: false,
    data: false,
    tipo: false,
  });
  const [openSnack, setOpenSnack] = useState(false);
  const [snack, setSnack] = useState({
    severity: "success",
    messaggio: "Salvataggio Effettuato correttamente",
    open: false,
  });
  const [visita, setVisita] = useState(null);
  const [orario, setOrario] = useState(null);
  const [isSaving, setIsSaving] = useState(false);

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
  };

  const columns = [
    {
      field: "Actions",
      headerName: "Azioni",
      width: 70,
      headerAlign: "center",
      align: "center",
      sort: "asc",
      renderCell: (params) => {
        return (
          <div>
            <IconButton
              aria-label="edit"
              onClick={() => {
                setSelectedAccertamento(params.row);
                setOpenEditDialog(true);
              }}
            >
              <Edit
                style={{ height: "2rem", width: "2rem", color: "#2265B1" }}
              />
            </IconButton>
          </div>
        );
      },
    },
    {
      field: "Descrizione",
      type: "string",
      headerName: "Accertamento",
      width: 300,
      renderCell: renderAccertamentoVisitaCell,
    },
    {
      field: "Scadenza",
      headerName: "Scadenza",
      type: "string",
      width: 150,
      renderCell: (params) =>
        params.row.Scadenza
          ? moment(params.row.Scadenza).format("DD/MM/YYYY")
          : "",
    },
    {
      field: "Importo",
      headerName: "Importo €",
      type: "number",
      width: 120,
      renderCell: (params) => (params.row.Importo ? params.row.Importo : 0),
    },
    {
      field: "ImportoPassivo",
      headerName: "ImportoPassivo €",
      type: "number",
      width: 150,
      renderCell: (params) =>
        params.row.ImportoPassivo ? params.row.ImportoPassivo : 0,
    },
  ];

  const handleOrarioChange = (event) => {
    let d = { ...visita };
    setOrario(event); //.format("HH:mm")
    //utilizzo la forma abbreviata della condizione if (Guard clauses)
    if (event) {
      d.Data =
        moment(visita.Data).format("YYYY-MM-DD") +
        " " +
        event.format("HH:mm:ss");
    }
  };

  const loadAccertamenti = async (val, data, cliente) => {
    let responseAccertamenti = await unsplash.get("accertamenti", {
      params: { id: val, data: data, clienteAcc: cliente },
      headers: {
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
    });

    const responseAcc = responseAccertamenti.data.data;
    setLoading(false);
    const selected = responseAcc.filter((acc) => acc.VisitaMedica);
    setSelectionModel(selected);
    const orderedOnOpen = [
      ...responseAcc.filter((acc) => acc.VisitaMedica),
      ...responseAcc.filter((acc) => !acc.VisitaMedica),
    ];
    setAccertamenti(orderedOnOpen);
  };

  const handleReorderCheck = (selected, acc) => {
    if (!selected) {
      selected = selectionModel;
      acc = accertamenti;
    }
    const safeSelected = Array.isArray(selected)
      ? selected.filter((s) => s && s.ID != null)
      : [];
    let IDSelected = safeSelected.map((s) => s.ID);

    let top = [];
    let bottom = [];
    for (let i = 0; i < acc.length; i++) {
      if (IDSelected.indexOf(acc[i].ID) >= 0) {
        top.push(acc[i]);
      } else {
        bottom.push(acc[i]);
      }
    }
    setAccertamenti(top.concat(bottom));
    setLoading(false);
  };

  const handleEditSave = async () => {
    try {
      const idsDaSalvare =
        selectedAccertamento?._ids?.length > 1
          ? selectedAccertamento._ids
          : [selectedAccertamento?.ID];
      const idsDaSalvareSet = new Set(idsDaSalvare.map(String));
      const scadenzaNormalizzata = selectedAccertamento.Scadenza
        ? moment(selectedAccertamento.Scadenza).format("YYYY-MM-DD")
        : null;
      await Promise.all(
        idsDaSalvare.map((id) => {
          const base =
            accertamenti.find((acc) => String(acc?.ID) === String(id)) || {};
          return unsplash.put(
            "accertamenti",
            {
              accertamento: applyAccertamentoVisitaEdit(
                base,
                selectedAccertamento,
                scadenzaNormalizzata,
              ),
              visitaId: props.visita.ID,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("jwt")}`,
              },
            },
          );
        }),
      );
      setAccertamenti((current) =>
        (current || []).map((acc) =>
          idsDaSalvareSet.has(String(acc?.ID))
            ? applyAccertamentoVisitaEdit(
                acc,
                selectedAccertamento,
                scadenzaNormalizzata,
              )
            : acc,
        ),
      );
      setSelectionModel((current) =>
        (current || []).map((acc) =>
          idsDaSalvareSet.has(String(acc?.ID))
            ? applyAccertamentoVisitaEdit(
                acc,
                selectedAccertamento,
                scadenzaNormalizzata,
              )
            : acc,
        ),
      );
      setSnack({
        severity: "success",
        messaggio: "Accertamento modificato con successo",
      });
      setOpenSnack(true);
      setOpenEditDialog(false);
    } catch {
      setSnack({
        severity: "error",
        messaggio: "Errore durante il salvataggio dell'accertamento",
      });
      setOpenSnack(true);
    }
  };

  const handleClickOpen = async () => {
    setVisita(props.visita);

    setAccertamenti([]);

    await loadAccertamenti(
      props.visita.ID,
      moment(props.visita.Data).format("YYYY-MM-DD"),
      props.visita.Cliente,
    );

    await setRequired({ medico: false, data: false, tipo: false });
    setOrario(props.visita.Data);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = async () => {
    if (isSaving) {
      return;
    }
    setIsSaving(true);
    let vis = { ...visita };
    vis.Data = vis.Data
      ? moment(vis.Data).format("YYYY-MM-DD") +
        " " +
        moment(orario).format("HH:mm:ss")
      : null;
    try {
      // Update the visita medica
      await unsplash.put(
        "visiteMediche",
        { visita: vis, accertamenti: selectionModel },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
        },
      );
      props.setSnack({
        severity: "success",
        messaggio: "Visita Medica modificata con successo",
      });
      props.setOpenSnack(true);

      handleClose();
      await props.reloadVisite();
    } catch {
      setSnack({
        severity: "error",
        messaggio: "Errore durante il salvataggio della visita medica",
      });
      setOpenSnack(true);
    } finally {
      setIsSaving(false);
    }
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
        >
          <GridToolbarQuickFilter placeholder="Cerca..." />
          <Button
            size="small"
            onClick={() => handleReorderCheck()}
            startIcon={<CheckBox />}
            style={{ border: 0 }}
          >
            Riordina
          </Button>
        </Grid>
      </GridToolbarContainer>
    );
  }

  const idsAccertamentiSelezionati = new Set(
    (selectionModel || [])
      .filter((sel) => sel && sel.ID != null)
      .map((sel) => sel.ID),
  );
  const accertamentiRaggruppati = buildAccertamentiVisitaRows(
    accertamenti,
    idsAccertamentiSelezionati,
    selectionModel,
  );
  const selectionModelGriglia = getAccertamentiVisitaSelectionRowIds(
    accertamentiRaggruppati,
    idsAccertamentiSelezionati,
  );

  return (
    <>
      <IconButton
        aria-label="edit"
        onClick={(event) => {
          event.currentTarget.blur();
          handleClickOpen();
          /* setVisitaSel(params.row);
              document.getElementById("myDialog").click(); */
        }}
      >
        <Edit style={{ height: "2rem", width: "2rem", color: "#2265B1" }} />
      </IconButton>
      {/* <Button
        variant="outlined"
        style={{ display: "None" }}
        onClick={handleClickOpen}
        id="myDialog"
      >
        Nuovo
      </Button> */}
      <GlobalSnackbar
        severity={snack.severity}
        messaggio={snack.messaggio}
        openSnack={openSnack}
        handleCloseSnack={handleCloseSnack}
      />
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="lg"
        onClick={(event) => event.stopPropagation()}
        onDoubleClick={(event) => event.stopPropagation()}
        TransitionComponent={Transition}
      >
        <DialogTitle>{"Modifica Visita"}</DialogTitle>
        <DialogContent>
          <Box sx={{ width: "100%" }}>
            <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
              <Grid container spacing={2}>
                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <FileUploader
                    visiteMedicheLavoratore={true}
                    colonna="VisitaMedica"
                    id={props.visita.ID}
                    colonnaExtra="Lavoratore"
                    extra={props.visita.Lavoratore}
                    description={
                      moment(props.visita.Data).format("DD-MM-YYYY") +
                      " - " +
                      props.lavoratore.Nome +
                      " " +
                      props.lavoratore.Cognome +
                      " - " +
                      props.lavoratore.CF
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  {required.tipo || required.data || required.medico ? (
                    <p style={{ color: "#FF2768" }}>
                      controlla i campi obbligatori!
                    </p>
                  ) : (
                    ""
                  )}
                </Grid>
                <Grid item xs={6}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Medico
                    </InputLabel>
                    <Select
                      error={required.medico}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={
                        props.medici?.some(
                          (medico) => medico.ID === visita?.IDMedico,
                        )
                          ? visita.IDMedico
                          : ""
                      }
                      label="Medico"
                      onChange={(e) => {
                        let medico = props.medici.filter(
                          (medico) => medico.ID === e.target.value,
                        )[0];
                        let text = medico.Nome + " " + medico.Cognome;
                        let v = { ...visita };
                        v.IDMedico = e.target.value;
                        v.Medico = text;
                        setVisita(v);
                      }}
                    >
                      <MenuItem value="">Nessuno</MenuItem>
                      {props.medici?.map((medico) =>
                        medico.ID !== -1 ? (
                          <MenuItem key={medico.ID} value={medico.ID}>
                            {medico.Nome + " " + medico.Cognome}
                          </MenuItem>
                        ) : null,
                      )}
                    </Select>
                    {required.medico && (
                      <Box
                        sx={{ color: "#d32f2f", fontSize: "0.75rem", mt: 0.5 }}
                      >
                        Medico obbligatorio
                      </Box>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={3}>
                  <LocalizationProvider dateAdapter={DateAdapter}>
                    <DatePicker
                      ampmInClock={false}
                      slotProps={{ textField: { error: required.data } }}
                      label="Data"
                      value={visita?.Data ? moment(visita.Data) : null}
                      onChange={(newValue) => {
                        let v = { ...visita };
                        if (newValue) {
                          v.Data = newValue.format("YYYY-MM-DD HH:mm:SS");
                        }
                        setVisita(v);
                      }}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={3}>
                  <LocalizationProvider dateAdapter={DateAdapter}>
                    <TimePicker
                      ampmInClock={false}
                      slotProps={{
                        textField: { fullWidth: true, error: required.ora },
                      }}
                      label="Ora"
                      value={orario ? moment(orario) : null}
                      onChange={handleOrarioChange}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item={true} xs={6}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Mansione
                    </InputLabel>
                    <Select
                      error={required.tipo}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={
                        props.mansioni?.some(
                          (mansione) => mansione.ID === visita?.IDMansione,
                        )
                          ? visita.IDMansione
                          : ""
                      }
                      label="Mansione"
                      onChange={(e) => {
                        let text = props.mansioni.filter(
                          (mansione) => mansione.ID === e.target.value,
                        )[0].Descrizione;
                        let v = { ...visita };
                        v.IDMansione = e.target.value;
                        v.Mansione = text;
                        setVisita(v);
                      }}
                    >
                      <MenuItem value="">Nessuna</MenuItem>
                      {props.mansioni?.map((mansione) => (
                        <MenuItem key={mansione.ID} value={mansione.ID}>
                          {mansione.Descrizione}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item={true} xs={6}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Tipologia Visita
                    </InputLabel>
                    <Select
                      error={required.tipo}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={
                        props.tipologiaVisita?.some(
                          (tipologia) => tipologia.ID === visita?.TipoVisita,
                        )
                          ? visita.TipoVisita
                          : ""
                      }
                      label="Tipologia Visita"
                      onChange={(e) => {
                        let text = props.tipologiaVisita.filter(
                          (tipologia) => tipologia.ID === e.target.value,
                        )[0].Descrizione;
                        let v = { ...visita };
                        v.TipoVisita = e.target.value;
                        v.TipoVDesc = text;
                        setVisita(v);
                      }}
                    >
                      <MenuItem value="">Nessuna</MenuItem>
                      {props.tipologiaVisita?.map((tipologia) => (
                        <MenuItem key={tipologia.ID} value={tipologia.ID}>
                          {tipologia.Descrizione}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Luogo"
                    multiline
                    value={visita?.Luogo ?? ""}
                    onChange={(e) => {
                      let v = { ...visita };
                      v.Luogo = e.target.value;
                      setVisita(v);
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <div style={{ height: 400, width: "100%" }}>
                    <DataGridPro
                      initialState={{ pinnedColumns: { left: ["Actions"] } }}
                      components={{
                        Toolbar: CustomToolbar,
                        Footer: CustomFooterPersonalized,
                      }}
                      slots={{
                        loadingOverlay: LinearProgress,
                      }}
                      loading={loading}
                      disableSelectionOnClick
                      disableColumnSorting
                      checkboxSelection
                      disableColumnMenu={true}
                      localeText={
                        itIT.components.MuiDataGrid.defaultProps.localeText
                      }
                      rows={accertamentiRaggruppati}
                      getRowId={getAccertamentiVisitaRowId}
                      columns={columns}
                      selectionModel={selectionModelGriglia}
                      onCellClick={(params, event) => {
                        if (params.field === "Scadenza") {
                          setSelectedAccertamento({
                            ...params.row,
                            _ids: params.row._ids,
                          });
                          setOpenEditDialog(true);
                          event.stopPropagation();
                        }
                      }}
                      onSelectionModelChange={(ids) => {
                        // guardiamo solo cosa è stato aggiunto/tolto rispetto
                        // a prima, per non "promuovere" a piena selezione un
                        // gruppo solo parzialmente selezionato senza che
                        // l'utente lo tocchi
                        const { aggiunti, rimossi } =
                          getAccertamentiVisitaSelectionChanges(
                            accertamentiRaggruppati,
                            ids,
                            selectionModelGriglia,
                          );
                        setSelectionModel((prev) => {
                          const { invariati, nuovi } =
                            getAccertamentiVisitaSelectedRows(
                              prev,
                              accertamenti,
                              aggiunti,
                              rimossi,
                            );
                          if (
                            nuovi.length > 0 &&
                            !nuovi[nuovi.length - 1].Scadenza
                          ) {
                            nuovi[nuovi.length - 1].Scadenza = visita
                              ? moment(visita.Data).format("YYYY-MM-DD")
                              : moment(new Date()).format("YYYY-MM-DD");
                          }
                          return [...invariati, ...nuovi];
                        });
                      }}
                    />
                  </div>
                </Grid>

                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Esito</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={
                        props.esiti?.some((esito) => esito.ID === visita?.Esito)
                          ? visita.Esito
                          : ""
                      }
                      label="Esito"
                      onChange={(e) => {
                        let text = props.esiti.filter(
                          (esito) => esito.ID === e.target.value,
                        )[0].Descrizione;
                        let v = { ...visita };
                        v.Esito = e.target.value;
                        v.EsitoDesc = text;
                        setVisita(v);
                      }}

                      //onChange={handleChange}
                    >
                      <MenuItem value="">Nessuno</MenuItem>
                      {props.esiti?.map((esito) => (
                        <MenuItem key={esito.ID} value={esito.ID}>
                          {esito.Descrizione}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Note"
                      multiline
                      value={visita?.Note ?? ""}
                      onChange={(e) => {
                        let v = { ...visita };
                        v.Note = e.target.value;
                        setVisita(v);
                      }}
                      sx={{ marginTop: "20px" }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mt: 2,
            pr: 4,
            pl: 2,
          }}
        >
          <Button
            variant="contained"
            className="ButtonMiller"
            startIcon={<Close />}
            onClick={handleClose}
          >
            Esci
          </Button>
          <Button
            variant="contained"
            className="ButtonMiller"
            startIcon={<Check />}
            onClick={handleSave}
            disabled={isSaving}
            color="success"
          >
            Salva
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openEditDialog}
        onClose={() => setOpenEditDialog(false)}
        maxWidth="sm"
        fullWidth
        onClick={(event) => event.stopPropagation()}
        onDoubleClick={(event) => event.stopPropagation()}
      >
        <DialogTitle>Modifica Accertamento</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Descrizione"
                value={selectedAccertamento?.Descrizione || ""}
                disabled
              />
            </Grid>
            <Grid item xs={12}>
              <LocalizationProvider dateAdapter={DateAdapter}>
                <DatePicker
                  label="Scadenza"
                  value={
                    selectedAccertamento?.Scadenza
                      ? moment(selectedAccertamento.Scadenza)
                      : null
                  }
                  onChange={(newValue) =>
                    setSelectedAccertamento({
                      ...selectedAccertamento,
                      Scadenza: newValue ? newValue.format("YYYY-MM-DD") : null,
                    })
                  }
                  slotProps={{ textField: { fullWidth: true } }}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Importo €"
                type="number"
                disabled={Boolean(selectedAccertamento?._isCategoriaGroup)}
                helperText={
                  selectedAccertamento?._isCategoriaGroup
                    ? "Totale del pacchetto"
                    : undefined
                }
                value={selectedAccertamento?.Importo || 0}
                onChange={(e) =>
                  setSelectedAccertamento({
                    ...selectedAccertamento,
                    Importo: e.target.value,
                  })
                }
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Importo Passivo €"
                type="number"
                disabled={Boolean(selectedAccertamento?._isCategoriaGroup)}
                helperText={
                  selectedAccertamento?._isCategoriaGroup
                    ? "Totale del pacchetto"
                    : undefined
                }
                value={selectedAccertamento?.ImportoPassivo || 0}
                onChange={(e) =>
                  setSelectedAccertamento({
                    ...selectedAccertamento,
                    ImportoPassivo: e.target.value,
                  })
                }
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenEditDialog(false)}>Annulla</Button>
          <Button onClick={handleEditSave} variant="contained" color="primary">
            Salva
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
const DeleteDialog = (props) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <IconButton aria-label="edit" onClick={handleClickOpen}>
        <Delete style={{ height: "2rem", width: "2rem", color: "#FF2768" }} />
      </IconButton>
      <Dialog
        open={open}
        onClose={handleClose}
        onClick={(event) => event.stopPropagation()}
        onDoubleClick={(event) => event.stopPropagation()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" sx={{ mx: "auto" }}>
          Sei sicuro di voler eliminare la visita selezionata?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Attenzione, sei sicuro di voler eliminare la seguente visita:
            <br />
            <b>{props.visita.Descrizione}</b>
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "space-between",
            px: 3,
          }}
        >
          <Button onClick={handleClose}>annulla</Button>
          <Button onClick={() => props.myFunction(props.visita)}>
            Conferma
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
